export const SET_PLACEMENTS = 'Editor/Placements/SET_PLACEMENTS';
